import { Navigate, Outlet } from 'react-router-dom';

function isTokenValid(token: string): boolean {
  try {
    const padded = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const payload = JSON.parse(atob(padded));
    return typeof payload.exp === 'number' && payload.exp * 1000 > Date.now();
  } catch {
    return false;
  }
}

/**
 * Renders child routes only when a valid, non-expired id_token is present in sessionStorage.
 * Otherwise redirects to /login and clears stale auth data.
 */
export default function ProtectedRoute() {
  const token = sessionStorage.getItem('id_token');

  if (!token || !isTokenValid(token)) {
    sessionStorage.removeItem('id_token');
    sessionStorage.removeItem('cre8or_auth_user');
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
